import React, { Component } from 'react';

class TimeBar extends Component {
  HOURS = 24;
  timeOfDay = [];
  increment = null;
  headerStyles = {}
  timeBarStyles = {}
  timeStyles = {}

  render() {
    this.increment = this.props.increment;

    this.headerStyles = { width: this.props.width, height: this.props.headerHeight, background: 'white' };
    this.timeBarStyles = { width: this.props.width, height: this.props.height-this.props.increment, background: 'white' };
    this.timeStyles = { position: 'absolute', top: '0%', left: '50%', transform: 'translate(-50%, -50%)' };

    for (var i = 0; i < this.HOURS; i++) { // FIXME I have deleted times of "0" and "24" because this time goes out of timeBar.
      if (i === 0)
        continue;

      this.timeOfDay[i] =
        <div key={i} className='mh2' style={{ height: this.increment, position: 'relative' }}>
          <span className='gray' style={this.timeStyles}>{i}</span>
        </div>
    }

    return (
      <div>
        <div style={this.headerStyles}></div>
        <div style={this.timeBarStyles}>
          {this.timeOfDay}
        </div>
      </div>
    );
  }
}

export default TimeBar;
